var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "base-wrapper",
  fillRule: "evenodd",
  transform: "translate(2 3)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "circle1",
  cx: 14,
  cy: 2,
  r: 2,
  opacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle2",
  cx: 18,
  cy: 9,
  r: 2,
  opacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle3",
  cx: 14,
  cy: 16,
  r: 2,
  opacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle4",
  cx: 6,
  cy: 16,
  r: 2,
  opacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle5",
  cx: 2,
  cy: 9,
  r: 2,
  opacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle6",
  cx: 6,
  cy: 2,
  r: 2,
  opacity: 0.6
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "fill-wrapper",
  fillRule: "evenodd",
  transform: "translate(2 3)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "circle1",
  cx: 14,
  cy: 2,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle2",
  cx: 18,
  cy: 9,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle3",
  cx: 14,
  cy: 16,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle4",
  cx: 6,
  cy: 16,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle5",
  cx: 2,
  cy: 9,
  r: 2.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "circle6",
  cx: 6,
  cy: 2,
  r: 2.1
}))));
export default SvgSpinner;